import { FC } from 'react'

import * as Styled from './styles'
import { IGrabHandlebarProps } from './types'

export const GrabHandleBar: FC<IGrabHandlebarProps> = ({ onClick }) => (
  <Styled.Button data-testid="grab-handle-bar" onClick={onClick} />
)
